import { takeEvery } from 'redux-saga/effects';
import { roomJoined } from 'features/room/roomSlice';
import { sessionEnded } from 'features/room/actions';
import { signalingDisconnected } from 'features/application/actions';
import {
  connectStatsTraceOnRoomJoined,
  closeStatsTrace,
} from 'features/system-stats/sagas/connectStatsTraceSaga';

export default function* systemStatsWatcher() {
  // Connect on join (idempotent), close on terminal teardown. Bound to session
  // boundaries so it survives media reconnect.
  yield takeEvery(roomJoined, connectStatsTraceOnRoomJoined);
  yield takeEvery([signalingDisconnected, sessionEnded], closeStatsTrace);
}
